// MOBILE STRUCTURE 

// PRODUCT DETAILS
function StructureProductDetails() {
  if ( ($('#product_details').length > 0) ) {
    if ($(window).width() < 901) {
      $(".woocommerce-product-gallery").appendTo($(".inject_mobile"));
    } else {
      $(".woocommerce-product-gallery").appendTo($(".col_demi.col_visu"));
    }
  }
}

// NAV
function StructureNavCart() {
  if ($(window).width() < 901) {  
    if ( ($('.cart_links_mobile').length == 0) ) {
      $( ".main_nav ul.cart_links" ).clone().addClass('cart_links_mobile').appendTo("nav > .container_full > .box_wrapper");
    }

    var cartLink = $('.call_cart_link').attr('href');
    if ( ($('.cart_links .cart .mobile_cart_link').length == 0) ) {
      $('.cart_links .cart .wrap').wrap('<a class="mobile_cart_link" href="'+cartLink+'" />');
    }
  } else {
    if ( ($('.cart_links .cart .mobile_cart_link').length > 0) ) {
      $('.cart_links .cart .wrap').unwrap();
    }
  }
}

// BOUTIQUE
function StructureBoutique() {
  if ( ($('#page_boutique').length > 0) ) {
    $( ".item" ).each(function() {
      if ($(window).width() < 1025) {
        $(this).find(".item_price").prependTo($(this).find(".expand"));
      } else {
        $(this).find(".item_price").appendTo($(this).find(".product_link .item_text"));
      }
    });
  }

  if ( ($('#page_boutique').length > 0 || $('#page_home').length > 0) ) {
    $( ".slide" ).each(function() {
      if ($(window).width() < 901) {
        $(this).find(".slide_price").prependTo($(this).find(".expand"));
      } else {
        $(this).find(".slide_price").appendTo($(this).find(".product_link .slider_text"));
      }
    });
  }
}

$(document).ready(function() {
  // PRODUCT DETAILS
  StructureProductDetails();

  // NAV
  StructureNavCart();

  // BOUTIQUE
  // StructureBoutique();
});

$(window).resize(function() {
  // PRODUCT DETAILS
  StructureProductDetails();

  // NAV
  StructureNavCart();

  // BOUTIQUE
  // StructureBoutique();
});